import isMatch from 'lodash/isMatch';
import isArray from  'lodash/isArray';

import  transform from 'lodash/transform';
import  isEqual  from 'lodash/isEqual';
import  isObject  from 'lodash/isObject';
import tinycolor2 from "tinycolor2";

function getFractionDigits(format) {
  if (typeof format !== 'string') return 0;

  format = format.trim();

  // Tách phần integer và phần decimal
  const match = format.match(/^.*([.,])([0#]+)$/);

  if (!match) {
    return 0;
  }

  const separator = match[1];
  const fraction = match[2];
  const integerPart = format.slice(
    0,
    format.length - fraction.length - 1
  );

  // Nếu separator xuất hiện trước đó,
  // nó đang được dùng làm grouping.
  if (integerPart.includes(separator)) {
    return 0;
  }

  return fraction.length;
}

function formatNumber(value, format) {
  const fractionDigits = getFractionDigits(format);

  return new Intl.NumberFormat('vi-VN', {
    useGrouping: true,
    //minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(Number(value));
}

function numeral(value) {
  return { 
    format(format = '') { 
      return formatNumber(value, format); 
    }, 
    value() { 
        return Number(value); 
    } 
  }; 
}



function difference(object, base) {
	return  transform(object, (result, value, key) => {
		if (!isEqual(value, base[key])) {
			result[key] = isObject(value) && isObject(base[key]) ? difference(value, base[key]) : value;
		}
	});
}
const createUniqueID =  ()=>{
  return '_' + Math.random().toString(36).substr(2, 9);
};
const EmitEvents={
  socket:{},
  events:{},
  dispatch:(event,data)=>{
    let handlers = EmitEvents.events[event];
    if(handlers){
      handlers.forEach(handler=>{
        handler(data);
      })
    }
  },
  subscribe:(event,handler)=>{
    if(!EmitEvents.events[event]) EmitEvents.events[event] = []
    if(!EmitEvents.events[event].find(h=>h==handler)){
      EmitEvents.events[event].push(handler);
    }
    return handler;
  },
  unsubscribe:(event,handler)=>{
    if(!EmitEvents.events[event]) return;
    if(!handler){
      delete EmitEvents.events[event];
    }else{
      EmitEvents.events[event] = EmitEvents.events[event].filter(h=>handler!=h);
    }
  }
}
const roundBy = Math.roundBy = function round(number, precision=0) {
  if (isNaN(number) || number === null) return 0;
  // Sử dụng ký pháp lũy thừa để tránh lỗi Math.round(1.005 * 100) = 100
  // Cách này giúp "dịch chuyển" dấu phẩy thập phân một cách chính xác hơn
  return Number(Math.round(number + 'e' + precision) + 'e-' + precision);
}
const round = roundBy;
const sum = Math.sum = function(array,field){
  let rs=0;
  array.forEach((item) => {
    rs = rs + Number(item[field]||0);
  });
  return rs;
}
const khoangSo = function(so){
  if(!so) return so;
  let _so =  so.toString().split(".")[0].split(",")[0];
  let _le = Number(_so.substring(_so.length-1));
  let _chan = Number(_so.substring(0,_so.length-1) + '0');

  if(_le<5){
    return `${_chan}-${_chan+5}`
  }else{
    return `${_chan + 5}-${_chan+10}`
  }
}

async function unicode2Ascii(str) {
  if(!str) return "";
  const {default:unidecode} = await import("unidecode");
  return unidecode(str);
}
function html2text(html){
  if(!html) return "";
  return html.replace(/(<([^>]+)>)/ig,"");
}
function random(n){
  return Math.floor(Math.random() * n)
}
function randomOf(gs){
  return gs[Math.floor(Math.random() * gs.length)]
}
const hex2rgba = (hex,opactiy=1) =>{
  if(!hex) return hex;
  return `rgba(${'0x' + hex[1] + hex[2] | 0}, ${'0x' + hex[3] + hex[4] | 0}, ${'0x' + hex[5] + hex[6] | 0},${opactiy})`;
}

function openFullscreen() {
  const elem = document.documentElement;
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
  }
}

function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}
function ColorLuminance(hex, lum) {
	// validate hex string
	hex = String(hex).replace(/[^0-9a-f]/gi, '');
	if (hex.length < 6) {
		hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
	}
	lum = lum || 0;
	// convert to decimal and change luminosity
	let rgb = "#", c;
	for (let i = 0; i < 3; i++) {
		c = parseInt(hex.substr(i*2,2), 16);
		c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
		rgb += ("00"+c).substr(c.length);
	}
	return rgb;
}

const STATUS_STYLE =new Map();
STATUS_STYLE.set("default",{
    color: "#1f1f1f",
    backgroundColor: "#f5f5f5",
    border: "1px solid #e0e0e0",
    borderRadius: "6px",
    padding: "4px 12px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    display: "inline-flex",
    alignItems: "center",
    number: {
      color: "#1f1f1f",
      backgroundColor: "rgba(0,0,0,0.08)",
      fontWeight: "bold",
      padding: "2px 6px",
      borderRadius: "4px",
      marginLeft: "6px",
    },
})
function getStatusStyles(color) {
  if(STATUS_STYLE.has(color)){
    return STATUS_STYLE.get(color);
  }
  try {
    const base = tinycolor2(color);
    // 1. Xử lý màu cơ bản (tươi sáng hơn)
    let hsl = base.toHsl();
    hsl.s = Math.min(hsl.s + 0.15, 1); 
    if (hsl.l < 0.2) hsl.l = 0.25; 
    if (hsl.l > 0.9) hsl.l = 0.9;

    const vibrantBase = tinycolor2(hsl);
    const isLight = vibrantBase.isLight();

    const backgroundColor = vibrantBase.toHexString();
    const textColor = isLight ? "#1f1f1f" : "#ffffff";
    
    // Tạo viền đậm hơn màu nền một chút để tạo độ khối sắc nét
    const borderColor = vibrantBase.clone().darken(15).toHexString();
    
    // Tạo hiệu ứng đổ bóng mờ (glow) trùng với màu của status để làm nổi bật
    const shadowColor = vibrantBase.setAlpha(0.3).toRgbString();

    const numberBackground = isLight 
        ? "rgba(0, 0, 0, 0.08)"
        : "rgba(255, 255, 255, 0.25)";

    const style = {
      // Style tổng thể của Status Tag
      color: textColor,
      backgroundColor: backgroundColor,
      border: `1px solid ${borderColor}`, // Viền rõ ràng
      borderRadius: "6px",                // Bo góc mềm mại (có thể đổi thành "999px" nếu muốn bo tròn dạng viên thuốc)
      padding: "4px 12px",                // Tạo không gian thở cho chữ
      fontWeight: "bold",                 // Chữ đậm để dễ đọc
      boxShadow: `0 2px 6px ${shadowColor}`, // Hiệu ứng nổi 3D nhẹ
      textTransform: "uppercase",         // In hoa chữ để trông giống nhãn dán (tùy chọn)
      fontSize: "0.75rem",                // Kích thước chữ vừa vặn, không lấn át dữ liệu chính
      letterSpacing: "0.5px",             // Khoảng cách chữ giúp dễ đọc hơn
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",

      // Style cho phần số (nếu có hiển thị số lượng đính kèm status)
      number: {
        color: textColor,
        backgroundColor: numberBackground,
        fontWeight: "bold",
        padding: "2px 6px",
        borderRadius: "4px",
        marginLeft: "6px", // Cách chữ status một khoảng nhỏ
        fontSize: "0.7rem",
      },
    };
    STATUS_STYLE.set(color,style);
    return style;
  } catch (e) {
    console.warn("getStatusStyles: invalid color input", color);
    return STATUS_STYLE.get("default");
  }
}

function gradientBackgroundStyle(maincolor,options = {brightenFirst:0,brightenSecond:15}){
  if(!maincolor) return {};
  if(options.brightenFirst){
    maincolor = tinycolor2(maincolor).brighten(options.brightenFirst).toString();
  }
  let maincolor2 = tinycolor2(maincolor).brighten(options.brightenSecond ||15).toString();
  let fontcolor = (tinycolor2(maincolor).isLight()?"black":"white");
  return {
    backgroundImage:`linear-gradient(${maincolor},${maincolor2})`,
    color:fontcolor
  }
}

function pivot(arr,p_rows,p_columns,options={min_columns:0}){
  //create rows
  let p_data_rows=arr.map(item=>{
    let _rs={};
    p_rows.forEach((p) => {
      _rs[p] = item[p]
    });
    return _rs;
  });
  let rows = [];
  p_data_rows.forEach((item) => {
    let condition = {...item}
    if(!rows.find(row=>isMatch(row,condition))){
      rows.push(item);
    }
  });
  //create columns for each row
  rows.forEach(row=>{
    let condition = {...row}
    row.p_columns = arr.filter(item=>{
      return isMatch(item,condition);
    }).map(a=>{
      let _p_data ={};
       p_columns.forEach((_c) => {
         _p_data[_c] = a[_c];
       });
       return _p_data
    })
    if(options.min_columns && row.p_columns.length < options.min_columns){
      row.p_columns = row.p_columns.concat(new Array(options.min_columns - row.p_columns));
    }
  })
  return rows;
}
function groupBy(data,groupFields,summaryFields=undefined){
  if(!data || !isArray(data) || !groupFields) return [];
  if(!summaryFields) summaryFields = ["count"];

  if(!isArray(groupFields)) groupFields =[groupFields];
  if(!isArray(summaryFields)) summaryFields =[summaryFields];

  const result= [];
  data.forEach(item=>{
    const condition= {};
    groupFields.forEach(f=>{
      condition[f] = item[f];
    })
    if(!result.find(r=>{
      return isMatch(r,condition)
    })){
      const g= {...condition};
      summaryFields.forEach(field=>{
        g[field] = data.filter(r=>isMatch(r,condition)).map(r=>r[field]||0).reduce((a,b)=>a+b,0);
      })
      result.push(g);
    }
  })
  return result;
}
const getRefCondition = async (master,data,field,token,API,context,listInfoCode)=>{
  if(!field.ref_condition){
      return null;
  }
  let string_func = field.ref_condition.indexOf("return ")>=0?field.ref_condition:`return ${field.ref_condition}`;
      string_func = `return (async ()=>{
          ${string_func}
      })()`
  try{
      const func= new Function("master","detail","data","field","API","token","context","userInfo","listInfoCode",string_func);
      return func(master||data,data,data,field,API,token,context,context.userInfo,listInfoCode);
  }catch(e){
      console.error(e.message,string_func);
      return null;
  }
}
const getItemsForPicker = async (context,id_app,field,query,options={},master={})=>{
  if(Array.isArray(field?.ref_model)){
    return field.ref_model;
  }
  if(field?.ref_model && (field?.ref_model.indexOf("{")>=0 || field.ref_model.indexOf("return ")>=0)){
    let func  = field.ref_model;
    if(func.indexOf("return ")<0){
      func = "return " + func;
    }
    try{
        return (new Function("master",func))(master);
    }catch(e){
        console.error(e.message,", expression:",func);
        return [];
    }
  }else{
    let token = context.userInfo?context.userInfo.token:context.config.public_token;
    let model = field.ref_api || field.ref_model;
    
    if(model==="dmtk") model ="account";
    if(model==="dmkh") model ="customer";
    if(model==="dmnt") model ="currency";
    let fields;
    if(!field.handle_value_changed || field.ref_data_fields || field.ref_search_fields){
        fields = (field.ref_data_fields || field.ref_search_fields  || field.ref_field) + ",bac,loai_nh";

        if(fields.indexOf(field.ref_field)<0){
            fields = `${fields},${field.ref_field}`;
        }
        if(field.ref_label && fields.indexOf(field.ref_label)<0){
            fields = `${fields},${field.ref_label}`;
        }
    }
    try{ 
      if(model=="trangthai"){
        let items= await context.apis.asyncGetList(token,"trangthaiapp",{id_app,condition:query,fields,limit:1000,cache_local:false,...options});
        if(items.length==0){
          items= await context.apis.asyncGetList(token,"trangthai",{id_app,condition:query,fields,limit:1000,cache_local:true,...options});
        }
        return items;
      }else{
        //console.log("get list",model,{id_app,condition:query,fields,limit:1000,cache_local:true,...options});
        return await context.apis.asyncGetList(token,model,{id_app,condition:query,fields,limit:1000,cache_local:true,...options})
      }
    }catch(e){
      console.error(e);
      return []
    }
  }
}
const getItemsForCompoleteInput = async (context,id_app,field,query,options={},master={})=>{
  if(Array.isArray(field.ref_model)){
      return field.ref_model;
  }
  if(field.ref_model.indexOf("{")>=0 || field.ref_model.indexOf("return ")>=0){
    let func  = field.ref_model;
    if(func.indexOf("return")<0){
      func = "return " + func;
    }
    try{
      return (new Function("master",func))(master);
    }catch(e){
      console.error(e.message,", expression:",func);
      return [];
    }
  }else{
      if(!options.online) return [];
      let token = context.userInfo?context.userInfo.token:context.config.public_token;
      
      let model = field.ref_api || field.ref_model;
      if(model==="dmtk") model ="account";
      if(model==="dmkh") model ="customer";
      if(model==="dmnt") model ="currency";
      //


      let fields;
      if(!field.handle_value_changed || field.ref_data_fields || field.ref_search_fields){

          fields = (field.ref_data_fields || field.ref_search_fields || field.ref_field) + ",bac,loai_nh";
          
          if(fields.indexOf(field.ref_field)<0){
              fields = `${fields},${field.ref_field}`;
          }
          if(field.ref_label && fields.indexOf(field.ref_label)<0){
              fields = `${fields},${field.ref_label}`;
          }
          
      }
      //
      try{
          return await context.apis.asyncGetList(token,model,{id_app,condition:query,limit:options.limit,fields,cache:options.cache,cache_local:options.cache})
          
      }catch(e){
          console.error(e);
          return []
      }
  }
}

const asyncMap = (arr,handle)=>{
  return Promise.all((arr||[]).map(item=>{
    return handle(item);
  }))
}
const JSONParse = (str)=>{
  if(typeof(str)=="object") return str;
  let func_string = str;
  if(func_string.indexOf("return ")<0) func_string = "return " + func_string;
  let func = new Function(func_string);
  return func();
}
const getCurrentPosition = async ()=>{
  if(!navigator.geolocation) throw "Không thể xác định vị trí hiện tại của bạn";
  return new Promise((rs,rj)=>{
    navigator.geolocation.getCurrentPosition((position)=>{
      rs(position.coords)
    },e=>{
      rj(e)
    });
  })
  
}
const formatCurrency = Math.formatCurrency = (data)=>{
  let gia_tri = Math.abs(data);
  //tiền tỷ
  if(gia_tri>=1000000000){
    gia_tri = gia_tri/1000000000;
    return `${data<0?"-":""}${numeral(gia_tri).format("0.0") + " tỷ"}` ;
  }
  //tiền triệu
  if(gia_tri>=1000000){
    gia_tri = gia_tri/1000000;
    return `${data<0?"-":""}${numeral(gia_tri).format("0") + " triệu"}` ;
  }
  //tiền ngàn
  if(gia_tri>=1000){
    gia_tri = gia_tri/1000;
    return `${data<0?"-":""}${numeral(gia_tri).format("0") + " ngàn"}` ;
  }
  return `${data<0?"-":""}${gia_tri}` ;

}
const formatRelativeTime = Date.formatRelativeTime = (dateInput, now = new Date())=> {
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) {
    return "Ngày không hợp lệ";
  }
  const diff = now.getTime() - date.getTime();
  const seconds = Math.round(Math.abs(diff) / 1000); // Luôn lấy giá trị dương
  const minutes = Math.round(seconds / 60);
  const hours = Math.round(minutes / 60);
  const days = Math.round(hours / 24);
  // ... (các đơn vị khác)

  const suffix = diff > 0 ? "trước" : "nữa"; // Xác định là quá khứ hay tương lai

  if (seconds < 5) {
    return diff > 0 ? "vài giây trước" : "trong vài giây";
  } else if (seconds < 60) {
    return `${seconds} giây ${suffix}`;
  } else if (minutes < 60) {
    return `${minutes} phút ${suffix}`;
  } else if (hours < 24) {
    return `${hours} giờ ${suffix}`;
  } else if (days < 7 && diff > 0 && days === 1) { // Xử lý "hôm qua"
      return "hôm qua";
  } else if (days < 7 && diff < 0 && days === 1) { // Xử lý "ngày mai"
      return "ngày mai";
  } else if (days < 30) { // Khoảng 4 tuần
    return `${days} ngày ${suffix}`;
  }
  // Thêm logic cho tháng, năm nếu cần
  else {
    // Fallback về định dạng ngày cụ thể nếu quá xa
    return date.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
}


let babelLoaderPromise = null;
function loadBabelOnce() {
  if (window.Babel) return Promise.resolve(window.Babel);
  if (babelLoaderPromise) return babelLoaderPromise; // instance khác dùng lại promise này
  babelLoaderPromise = new Promise((resolve, reject) => {
    const scriptTag = document.createElement('script');
    scriptTag.src = "https://unpkg.com/@babel/standalone@7.27.0/babel.min.js";
    scriptTag.onload = () => resolve(window.Babel);
    scriptTag.onerror = (e) => { babelLoaderPromise = null; reject(e); }; // cho phép retry
    document.head.appendChild(scriptTag);
  });
  return babelLoaderPromise;
}




export {
  EmitEvents,
  createUniqueID,
  khoangSo,
  random,
  randomOf,
  unicode2Ascii,
  html2text,
  hex2rgba,
  openFullscreen,
  closeFullscreen,
  ColorLuminance,
  gradientBackgroundStyle,
  getStatusStyles,
  pivot,
  groupBy,
  difference,
  sum,
  asyncMap,
  JSONParse,
  formatCurrency,
  round,
  roundBy,
  getRefCondition,
  getItemsForPicker,
  getItemsForCompoleteInput,
  getCurrentPosition,
  formatRelativeTime,
  loadBabelOnce,
  getFractionDigits,
  numeral
}
